var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visibleLayers.length
    ? _c(
        "v-card",
        {
          staticClass: "map-layer-legend",
          attrs: { width: "260", outlined: "" },
        },
        [
          _c(
            "v-expansion-panels",
            _vm._l(_vm.visibleLayers, function (layer) {
              return _c(
                "v-expansion-panel",
                { key: layer.id },
                [
                  _c("v-expansion-panel-header", { staticClass: "py-1" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex align-center flex-wrap" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "text-caption font-weight-medium mr-2",
                          },
                          [_vm._v(_vm._s(layer.name))]
                        ),
                        _vm._l(
                          _vm.previewColors(layer),
                          function (color, category) {
                            return _c("span", {
                              key: category,
                              staticClass: "legend-dot",
                              style: { backgroundColor: color },
                            })
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                  _c("v-expansion-panel-content", [
                    layer.categories
                      ? _c(
                          "div",
                          { staticClass: "mb-2" },
                          [
                            _c("p", { staticClass: "text-overline mb-1" }, [
                              _vm._v("Category"),
                            ]),
                            _c(
                              "v-chip-group",
                              {
                                attrs: {
                                  value: _vm.activeFilter(layer.id).category,
                                  column: "",
                                },
                                on: {
                                  change: function (v) {
                                    return _vm.setFilter(
                                      layer.id,
                                      "category",
                                      v
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-chip",
                                  { attrs: { small: "", value: null } },
                                  [_vm._v("All")]
                                ),
                                _vm._l(
                                  layer.categories,
                                  function (color, category) {
                                    return _c(
                                      "v-chip",
                                      {
                                        key: category,
                                        attrs: { small: "", value: category },
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "legend-dot mr-1",
                                          style: { backgroundColor: color },
                                        }),
                                        _vm._v(" " + _vm._s(category) + " "),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    layer.categoriesSecondary
                      ? _c(
                          "div",
                          [
                            _c("p", { staticClass: "text-overline mb-1" }, [
                              _vm._v("Secondary category"),
                            ]),
                            _c(
                              "v-chip-group",
                              {
                                attrs: {
                                  value: _vm.activeFilter(layer.id)
                                    .categorySecondary,
                                  column: "",
                                },
                                on: {
                                  change: function (v) {
                                    return _vm.setFilter(
                                      layer.id,
                                      "categorySecondary",
                                      v
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-chip",
                                  { attrs: { small: "", value: null } },
                                  [_vm._v("All")]
                                ),
                                _vm._l(
                                  layer.categoriesSecondary,
                                  function (color, category) {
                                    return _c(
                                      "v-chip",
                                      {
                                        key: category,
                                        attrs: { small: "", value: category },
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "legend-dot mr-1",
                                          style: { backgroundColor: color },
                                        }),
                                        _vm._v(" " + _vm._s(category) + " "),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }